import {setGlobal} from '@netx/core-next/utils/setGlobal';
import NotificationsCollection from '../collections/notifications';

export const notifications = new NotificationsCollection([]);

export default notifications;

if (process.env.NODE_ENV !== 'production') {
	setGlobal({notifications});
}
